import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GetAppIcon(props: IconProps) {
    return <Icon {...props} iconKey={"get_app"}/>
}
